import {TableHead} from '@mui/material';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import PropTypes from 'prop-types';

const DocInvTableHeading = ({fields}) => {
  return (
    <TableHead>
      <TableRow>
        {fields
          .filter((field) => field.visibility === 'show')
          .map((field) => (
            <TableCell key={field.name} align={field.alignlabel || 'left'}>
              {field.label}
            </TableCell>
          ))}
      </TableRow>
    </TableHead>
  );
};

DocInvTableHeading.propTypes = {
  fields: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default DocInvTableHeading;
